//
// Australian bird plumages
// https://github.com/shandiya/feathers
//
export default [
  {
    name: 'spotted_pardalote',
    colors: ['#feca00', '#d36328', '#cb0300', '#b4b9b3', '#424847', '#000100'],
    type: 'feathers',
  },
  {
    name: 'plains_wanderer',
    colors: ['#edd8c5', '#d09a5e', '#e7aa01', '#ac570f', '#73481b', '#442c0e', '#0d0403'],
    type: 'feathers',
  },
  {
    name: 'bee_eater',
    colors: ['#00346E', '#007CBF', '#06ABDF', '#EDD03E', '#F5A200', '#6D8600', '#424D0C'],
    type: 'feathers',
  },
  {
    name: 'rose_crowned_fruit_dove',
    colors: ['#BD338F', '#EB8252', '#F5DC83', '#CDD4DC', '#8098A2', '#8FA33F', '#5F7929', '#014820'],
    type: 'feathers',
  },
  {
    name: 'eastern_rosella',
    colors: ['#cd3122', '#f4c623', '#bee183', '#6c905e', '#2f533c', '#b8c9dc', '#2f7ab9'],
    type: 'feathers',
  },
  {
    name: 'oriole',
    colors: [
      '#8a3223',
      '#bb5645',
      '#d97878',
      '#e2aba0',
      '#d0cfe9',
      '#a29eb8',
      '#6c6b75',
      '#b8a53f',
      '#93862a',
      '#4d4019',
    ],
    type: 'feathers',
  },
  {
    name: 'princess_parrot',
    colors: ['#7090c9', '#8cb3de', '#afbe9f', '#616020', '#6eb245', '#214917', '#cf2236', '#d683ad'],
    type: 'feathers',
  },
  { name: 'superb_fairy_wren', colors: ['#4F3321', '#AA7853', '#D9C4A7', '#B03F05', '#020503'], type: 'feathers' },
  {
    name: 'cassowary',
    colors: ['#BDA14D', '#3EBCB6', '#0169C4', '#153460', '#D5114E', '#A56EB6', '#4B1C57', '#09090C'],
    type: 'feathers',
  },
  {
    name: 'yellow_robin',
    colors: ['#E19E00', '#FBEB5B', '#85773A', '#979EB9', '#727B98', '#454B56', '#201B1E'],
    type: 'feathers',
  },
  { name: 'galah', colors: ['#FFD2CF', '#E9A7BB', '#D05478', '#AAB9CC', '#8390A2', '#4C5766'], type: 'feathers' },
];
